import { ResourceType } from "@common/types/auditLog";
import { APIProcessName, SQSProcessName } from "../process-names";
import {
    BANK_RECONCILIATION_SOURCE_TYPES,
    BankReconciliationSourceType,
} from "./bank-reconciliation-source-types";
import { HistoryField, HistoryGroupBy } from "./history-fields";
import type { HistorySourceTypeConfig } from "./history-source-config";
import { FINANCIAL_ACCOUNT_FIELDS } from "./source-fields";
import { TRANSACTION_FIELDS } from "./transaction-sources";

function buildBankReconciliationSourceConfig(
    sourceType: BankReconciliationSourceType,
): HistorySourceTypeConfig {
    return {
        sourceType,
        resourceTypeConfigs: [
            {
                resourceType: ResourceType.BANK_RECONCILIATION,
                fields: [HistoryField.FINANCIAL_ACCOUNT_ID],
                resolveEntity: true,
            },
        ],
        groupBy: HistoryGroupBy.DIFF_VALUE,
        groupByDiffField: HistoryField.FINANCIAL_ACCOUNT_ID,
        platformTwins: null,
        enabled: true,
    };
}

export const reconciliationSources: HistorySourceTypeConfig[] = [
    ...BANK_RECONCILIATION_SOURCE_TYPES.map(
        buildBankReconciliationSourceConfig,
    ),
    {
        sourceType: APIProcessName.RECONCILE_LOAN,
        resourceTypeConfigs: [
            {
                resourceType: ResourceType.TRANSACTION,
                fields: [HistoryField.RECONCILED_IN_ID],
            },
        ],
        groupBy: HistoryGroupBy.NONE,
        platformTwins: null,
        enabled: false,
    },
    {
        sourceType: APIProcessName.BANK_RECONCILIATION_DELETE,
        resourceTypeConfigs: [
            {
                resourceType: ResourceType.BANK_RECONCILIATION,
                fields: [HistoryField.RECONCILED_IN_ID],
            },
        ],
        groupBy: HistoryGroupBy.NONE,
        platformTwins: null,
        enabled: false,
    },
];

export const financialAccountSources: HistorySourceTypeConfig[] = [
    {
        sourceType: APIProcessName.FINANCIAL_ACCOUNT_UPDATE,
        resourceTypeConfigs: [
            {
                resourceType: ResourceType.FINANCIAL_ACCOUNT,
                fields: FINANCIAL_ACCOUNT_FIELDS,
            },
        ],
        groupBy: HistoryGroupBy.FIELD,
        platformTwins: [APIProcessName.PLATFORM_UPDATE_FINANCIAL_ACCOUNT],
        enabled: true,
    },
    {
        sourceType: SQSProcessName.ACCOUNT_ENTITY_CHANGE,
        resourceTypeConfigs: [
            {
                resourceType: ResourceType.FINANCIAL_ACCOUNT,
                fields: FINANCIAL_ACCOUNT_FIELDS,
            },
            {
                resourceType: ResourceType.TRANSACTION,
                fields: TRANSACTION_FIELDS,
            },
        ],
        groupBy: HistoryGroupBy.FIELD,
        platformTwins: null,
        enabled: true,
    },
    {
        sourceType: APIProcessName.FINANCIAL_ACCOUNT_DELETE,
        resourceTypeConfigs: [
            {
                resourceType: ResourceType.FINANCIAL_ACCOUNT,
                fields: FINANCIAL_ACCOUNT_FIELDS,
            },
        ],
        groupBy: HistoryGroupBy.NONE,
        platformTwins: [APIProcessName.PLATFORM_DELETE_FINANCIAL_ACCOUNT],
        enabled: true,
    },
    {
        sourceType: APIProcessName.FINANCIAL_ACCOUNT_MERGE_ACCOUNTS,
        resourceTypeConfigs: [
            {
                resourceType: ResourceType.FINANCIAL_ACCOUNT,
                fields: FINANCIAL_ACCOUNT_FIELDS,
            },
        ],
        groupBy: HistoryGroupBy.NONE,
        platformTwins: null,
        enabled: true,
    },
    {
        sourceType: SQSProcessName.FINANCIAL_ACCOUNT_MERGING,
        resourceTypeConfigs: [
            {
                resourceType: ResourceType.FINANCIAL_ACCOUNT,
                fields: FINANCIAL_ACCOUNT_FIELDS,
            },
        ],
        groupBy: HistoryGroupBy.NONE,
        platformTwins: null,
        enabled: true,
    },
];
